<template>
	<div id="searchResultProductList" style="background:transparent;"> <!-- produktlista popover sökresultat -->


		<div style="" class="">

			<div v-if="this.debug && this.searchProductResult && this.searchProductResult.meta"
				style="background:var(--grey-6);margin-bottom:10px;padding:10px;color:white;border-radius: 5px;">
				{{ this.searchProductResult.meta }} Antal: {{ this.searchProductResult &&
				this.searchProductResult.productList
				? this.searchProductResult.productList.length : '' }}
			</div>

			<!-- Visa antalet träffar -->
			<!--div class="link"
				style="background:var(--bg-message);color:white; padding:10px;border-radius: 5px;margin-bottom:5px;position:sticky;top:0px;z-index:10;text-align:center;">
				{{ this.resultCountLabel}}
			</div -->


			<!-- sök grid -->

			<div v-if="this.rebuildingSearchModel"
				style="position: fixed;z-index:10;background:var(--grey-1);padding:10px;border-radius: 5px;"
				class="flexcenter drop-shadow-light">
				<Icon fileName="w3_spinner_grey" class="spinner"
					style="margin-right:5px;margin-left:5px;width:20px;height:20px;" />
				<b class="font-smaller" style="color:grey;margin-left:5px;margin-right:5px;" >Bygger om sökindex</b>
			</div>
			<div id="productGrid">
				<!-- anpassad max-height: min(calc(100vh - 300px) från App.vue, 600px); för footern med stäng -->

				<SearchResultProductCell v-for="(product) in this.model.productListSearch" :key="product.productId"
					:productId="product.productId" :searchEntity="product.entity" class="productCell" :parentTitle="this.title"
					@showProductDetails="((product) => {this.$emit('showProductDetails', product) })" />

			</div>
			<!-- footer -->
			<!--div class="link"
				style="height:45px;background:var(--bg-message); border-radius: 5px;color:white;">{{
				this.resultCountLabel }}</div -->
		</div>
	</div>
</template>
<script>
import { STORE_GETTER } from '../../../store/store';
import SearchResultProductCell from './SearchResultProductCell.vue';



export default {
	name: "SearchResultProductList",
	components: { SearchResultProductCell },
	mixins: [],
	props: {
		model:Object,
		parentTitle:String,
	},
	data() {
		return {

		};
	},
	computed: {

		title(){
			return this.parentTitle + "\nSearchResultProductList"
		},

		resultCountLabel(){
			if (this.model.resultCount > 0){
				return "Stäng och visa alla sökträffar";
			}
			return "Hitta inga matchande produkter, prova att söka på något annat.";
		},

		searchProductResult() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_RESULT];
		},
		searchProductConfig() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},
		rebuildingSearchModel() {
			return this.$store.getters[STORE_GETTER.REBUILDING_SEARCH_MODEL];
		}



	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });


	},
	created() {

	}
};
</script>

<style scoped>

/*div#productGrid {
	display: grid;
	gap: 10px;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	grid-template-rows: repeat(minmax(150px, 200px));
}

@media (max-width: 620px) {
	div#productGrid {
		grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
	}
}*/

div#productGrid {
		display: grid;
		column-gap: 10px;
		row-gap: 0px;
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		grid-template-rows: repeat(3, auto);
		grid-auto-rows: 0px;
		position: relative;
		overflow: hidden;
}

div#productGrid div.productCell{
	background: var(--grey-1);
	padding: 5px;
	min-height: 120px;
	max-height: 220px;;
	overflow: hidden;
	margin-bottom: 10px;
}

@media (max-width: 620px) {
	div#productGrid {
		grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
		grid-template-rows: repeat(3, auto);
		
	}

		
}


div#searchResultProductList{
	width:66%;
}

@media (max-width: 7680px) {
	div#searchResultProductList {
		width: 100%;
	}
}

</style>